module.exports = __webpack_public_path__ + "img/other-overheads-icon.e1d94430.svg";